import { gql } from '@/__generated__';

const FETCH_VIRTUAL_STATION_MEASUREMENTS = gql(`#graphql
  query GetMeasurements($deviceId: ID!) {
    device(input: { id: $deviceId }) {
      id
      regis {
        id
        measurements {
          id
          user {
            id
            fullName
          }
          level
          flow
          photo
          device {
            id
            profile {
              id
              name
            }
          }
          timestamp
        }
      }
    }
  }
`);

export default FETCH_VIRTUAL_STATION_MEASUREMENTS;
